export default __webpack_public_path__ + "static/media/pfotenphysio.4701dbcd.webm";